<template>
  <div class="d-flex flex-column align-center mb-8" id="editableContainer">
    <v-form class="mx-auto align-center text-center my-4 d-flex" title="container and layout options" v-if="editing">
      <v-btn-toggle dark background-color="transparent" v-model="containerSize">
        <v-btn small color="transparent">
          <v-icon color="black">mdi-arrow-collapse-horizontal</v-icon>
        </v-btn>
        <v-btn small color="transparent">
          <v-icon color="black">mdi-arrow-expand-horizontal</v-icon>
        </v-btn>
      </v-btn-toggle>
      <v-menu offset-y>
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" small dark :class="'lighten-1 ' + bgColorName" title="colors" elevation="0">
            <v-icon color="black">mdi-palette</v-icon>
          </v-btn>
        </template>
        <div class="d-flex">
          <v-btn v-for="(c,i) in bgColors" 
            :key="i" 
            small tile elevation="0" 
            @click="updateColor(i)" 
            v-show="bgColorName!==c"
            :color="c"
            :title="c">  
          </v-btn>
        </div>
      </v-menu>
      <v-menu offset-y :close-on-content-click="false" max-width="380px">
        <template v-slot:activator="{ on }">
          <v-btn v-on="on" small dark color="transparent" title="tags" elevation="0">
            <v-icon color="black">mdi-tag</v-icon>
          </v-btn>
        </template>
        <v-layout wrap class="pa-3 white">
          <v-flex xs12>
            <h5>SEO-friendly Metadata</h5>
            <v-text-field hide-details label="Name" title="SEO friendly title" v-model="post.title" @change="setDirty()"></v-text-field>
            <v-text-field hide-details label="Description" title="SEO friendly description" v-model="post.desc" @change="setDirty()"></v-text-field>
          </v-flex>
          <v-flex xs12 class="mt-2">
            <v-autocomplete
              title="SEO friendly keywords"
              v-model="post.tags"
              :items="tags"
              clearable
              hide-selected
              auto-select-first
              label="Tags"
              multiple
              @change="setDirty()"
              class="caption"
              :menu-props="{
                light:true,
                contentClass:'white',
                closeOnContentClick:true,
                maxHeight:'240px'
              }">
              <template v-slot:selection="{ attrs, item, select, selected, index }">
                <v-chip
                  small
                  v-bind="attrs"
                  :input-value="selected"
                  v-show="index < 3"
                  close
                  @click="select"
                  @click:close="removeTag(item)"
                  class="mr-1 text-truncate"
                  >
                  {{ item }}
                </v-chip>
                <v-chip small outlined color="primary" v-if="index === 3">
                  +{{ post.tags.length - 3}}
                </v-chip>
              </template>
              <template v-slot:prepend-item="{ select }">
                <div class="px-4 py-3" v-show="post.tags && post.tags.length > 0">
                  <div class="overline px-1">Selected Tags</div>
                  <v-chip 
                      close
                      @click="select"
                      @click:close="removeTag(t)"
                      class="mr-1" color="primary" v-for="t in post.tags" small :key="t">
                      {{ t }}
                  </v-chip>
                </div>
              </template>
              <template v-slot:item="{ item }">
                <v-chip
                small>{{ item }}</v-chip>
              </template>
            </v-autocomplete>
          </v-flex>
          <v-flex xs12>
            <v-btn>Save</v-btn>
          </v-flex>
        </v-layout>
      </v-menu>
    </v-form>
    <v-sheet :class="containerClasses" :width="containerWidth" :elevation="0" :color="editing?'white':bgColorName">
      <div ref="editables" class="editable-container" :key="i" v-for="(editable,i) in editables" >
        <editable :classes="editable.classes" v-model="editable.v" :key="i"
          :mode="editable.mode"
          :editing="editing"
          :max-length="editable.maxLength"
          :delete-me="deleteEditable">
        </editable>
        <div class="picker-container py-7">
            <editable-menu v-show="editing" :insert-editable="insertEditable" :idx="i"></editable-menu>
        </div>
      </div>
    </v-sheet>
  </div>
</template>

<script>
import Editable from '@/components/core/Editable.vue'
import EditableMenu from '@/components/core/EditableMenu.vue'

export default {
  name: 'EditableContainer',
  data:() => ({
    containerSize: 0,
    bgColors: ['cyan','orange darken-1','blue-grey','pink darken-2','white','blue'],
    bgColor: 0,
    tags: ['vue','javascript','react','html'],
    post: {
      title: 'My Post title',
      tags: ['vue','javascript']
    }
  }),
  components: {
    Editable,
    EditableMenu
  },
  props: {
    editables: {
      type: Array,
      default() {
        return []
      }
    },
    editing: {
      type: Boolean,
      default: false
    },
    bgColorName: String
  },
  computed: {
    containerClasses() {
      return {
        'editables-list mt-3 px-5 py-7':true
      }
    },
    containerWidth() {
      return this.containerSize===0?'800px':'100%'
    }
  },
  methods: {
    insertEditable(idx,classes,mode,starter) {
      console.log(this.editables)
      let editables = [...this.editables]
      this.editables.splice((idx+1),0,{v:starter||'...',classes,mode})
      console.log(editables)
      //this.editables = [...editables]
      console.log(this.editables)
      
      setTimeout(()=>{
          //console.log(this.$refs.editables)
          let justAdded = this.$refs.editables[idx+1].querySelector('[contenteditable]')
          justAdded.focus()
          justAdded.click()
      }, 400)
    },
    deleteEditable(idx) {
      if (!this.editables[idx].noDelete) {
        console.log('i am gone!',idx)
        this.editables.splice(idx,1)
      }
      else {
        console.log('sorry you can`t get rid of me!')
      }
    },
    updateColor(i){
      console.log('updateColor')
      this.$emit('update:bg-color-name', this.bgColors[i])
    },
    setDirty() {},
    removeTag(t) {
        this.post.tags.splice(this.post.tags.indexOf(t),1)
        this.setDirty()
    }
  }
}
</script>
